import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2 15.5c0-.886.177-1.73.498-2.5H2a1 1 0 1 1 0-2h1.81A6.48 6.48 0 0 1 8.5 9c1.843 0 3.508.767 4.69 2h5.62a6.48 6.48 0 0 1 4.69-2c1.843 0 3.508.767 4.69 2H30a1 1 0 1 1 0 2h-.498a6.5 6.5 0 1 1-12.004 0h-2.996A6.5 6.5 0 1 1 2 15.5M8.5 11a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m15 0a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconEyeglasses = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconEyeglasses);
export default Memo;
